export * from './none-codec.js';
export * from './scalar-codec.js';
export * from './angle-codec.js';
export * from './level-codec.js';
import { Codecs } from '../types.js';
import { NoneCodec } from './none-codec.js';
import { ScalarCodec } from './scalar-codec.js';
import { AngleCodec } from './angle-codec.js';
import { LevelCodec } from './level-codec.js';
export const createCodec = (definition) => {
    switch (definition.id) {
        case Codecs.NONE: return NoneCodec.get(definition);
        case Codecs.SCALAR: return ScalarCodec.get(definition);
        case Codecs.ANGLE: return AngleCodec.get(definition);
        case Codecs.LEVEL: return LevelCodec.get(definition);
    }
};
